/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { useTranslation } from 'react-i18next';
import { BodyText, Icon, Size } from '@vaisala-rockhopper/components';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { ValidityState } from '../../../../modules/calculator/polaris-pr53/calculatorTypes';
import './ValidityIndicator.scss';
import { isMobileOnly } from 'react-device-detect';

interface ValidityIndicatorProps {
  state?: ValidityState;
  onShowHelp: VoidFunction;
}

const ValidityIndicator = ({ state, onShowHelp }: ValidityIndicatorProps) => {
  const { t } = useTranslation();

  const getIcon = () => {
    switch (state?.reason) {
      case 'condensation':
      case 'condensationNear':
        return VaiIcon.Drop;
      case 'pressureHigh':
      case 'zeroDuration':
        return VaiIcon.Timer;
      case 'temperatureHigh':
        return VaiIcon.Thermometer;
      case 'frostForming':
        return VaiIcon.SnowFlake;
    }
  };

  return (
    <div
      className={`validity-indicator ${state ? state.severity : 'off'} ${
        isMobileOnly ? 'validity-indicator--mobile' : 'validity-indicator--desktop'
      }`}
    >
      <div className="validity-indicator__grid">
        <div className="validity-indicator__grid-item">
          <div className="validity-indicator__content-wrap" onClick={onShowHelp}>
            <Icon name={getIcon()} size={Size.L} />
            <BodyText>
              <span className="validity-indicator__header">{state && state.reason ? t(`ui.validity.header.${state.reason}`) : ''}</span>
              <br />
              <span className="validity-indicator__link">{state && state.reason ? t(`ui.validity.sub.${state.reason}`) : ''}</span>
            </BodyText>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValidityIndicator;
